export const listKnowledgebaseConfig = () => ({
  url: `/v2/knowledge_base`,
});

export const getKnowledgebaseConfig = (knowledgebaseId) => ({
  url: `/v2/knowledge_base/${knowledgebaseId}`,
});

export const createKnowledgebaseConfig = () => ({
  url: `/v2/knowledge_base`,
});

export const updateKnowledgebaseConfig = (knowledgebaseId) => ({
  url: `/v2/knowledge_base/${knowledgebaseId}`,
});

export const deleteKnowledgebaseConfig = (knowledgebaseId) => ({
  url: `/v2/knowledge_base/${knowledgebaseId}`,
});

export const listKnowledgebaseSourcesConfig = () => ({
  url: `/v2/knowledge_base_sources`,
});

export const listKnowledgebaseTypesConfig = () => ({
  url: `/v2/knowledge_base_types`,
});
